export function initSubscriptionButton() {
    const btn = document.getElementById('btn-abo');
    const inputValue = document.getElementById('input-mail-sub');
    const messageError = document.getElementById('error-email');
    if (!btn || !inputValue) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function validateEmail(email) {
        return emailRegex.test(email);
    }

    function toggleError(valid) {
        if (valid) {
            inputValue.classList.add('border-red-600');
            messageError?.classList.remove('hidden');
        } else {
            inputValue.classList.remove('border-red-600');
            messageError?.classList.add('hidden');
        }
    }

    // validation en temps réel
    inputValue.addEventListener('input', function() {
        toggleError(this.value && !validateEmail(this.value));
    });

    btn.addEventListener('click', function(e) {
        e.preventDefault();
        const formMail = inputValue.value.trim();
        if (!formMail || !validateEmail(formMail)) {
            toggleError(true);
            return;
        }
        toggleError(false);
        const  url = "https://abonnement.satellifacts.com/index.php?page=abonnement&action=etape_1&t=MjMuMGRlZjdhNzBhN2U3ZjBhNmRjMDMyZTE4NDI2ODJhNjU0ZWZjODFmMjQ1NWNjMmZhOTM3YmZhODE5NTk3Y2I2Yw&NLem=" + encodeURIComponent(formMail);
        window.location.href = url;
    });
}